<template>
    <!--
        What a visitor sees when the hotel has not bought the booking engine at all.
        It replaces the site rather than sitting in the layout: the topbar has no house
        to name and every step underneath leads to the same refusal.

        Close in tone to Closed.vue and deliberately a separate screen: that one is
        drawn from an empty answer and means "not selling here right now", while this
        one is the API saying precisely which door is shut. The visitor is told the
        same useful thing either way — ring the hotel — but a hotelier reporting a
        broken booking page needs the two told apart.

        No button of any kind. A retry would ask a locked door the same question, and
        there is no list to send anybody back to: this deployment sells one house, so
        the notice IS the site while it stands. The way back is the house changing,
        which `libs/license.ts` describes and `stores/booking.ts` does.
    -->
    <div class="grid min-h-screen place-items-center bg-muted p-6">
        <UCard class="w-full max-w-md text-center">
            <div class="mx-auto grid size-14 place-items-center rounded-full bg-elevated">
                <UIcon name="i-lucide-door-closed" class="size-7 text-dimmed" />
            </div>

            <h1 class="mt-4 text-2xl font-bold text-highlighted">{{ $t('license.title') }}</h1>

            <!-- The house, only where the site got as far as learning its name. It
                 usually has not: the house is read from the very branch that is
                 refused. -->
            <p v-if="hotel" class="mt-1 text-sm font-medium text-toned">{{ hotel }}</p>

            <p class="mx-auto mt-3 max-w-sm text-sm text-muted">{{ $t('license.lead') }}</p>
            <p class="mx-auto mt-4 max-w-sm text-xs text-dimmed">{{ $t('license.contact') }}</p>
        </UCard>
    </div>
</template>

<script lang="ts" setup>
    import { computed } from 'vue'

    import { useBookingStore } from '@/stores/booking'

    const store = useBookingStore()

    const hotel = computed((): string =>
        store.property?.appearance?.display_name || store.property?.name || '')
</script>
